import { observer } from "mobx-react";
import { useEffect, useState } from "react";

import ActionLink from "./ActionLink/ActionLink";

import "./ActivityList.scss";

const ActivityList = observer(({ store, isMobile }) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const { market } = store.currentMarketStore;

  useEffect(() => {
    setIsAnimated(true);
    const timer = setTimeout(() => setIsAnimated(false), 300);
    return () => clearTimeout(timer);
  }, [market]);

  return (
    <div className={`main__services_activity ${isAnimated ? 'animated' : ''}`}>
      <div className={`main__services_activity-list ${isAnimated ? 'animated' : ''}`}>
        {market.mainPageTitles.map((action, index) => (
          <ActionLink
            key={index}
            action={{
              ...action,
              titleComment: action.titleComment,
              icon: action.iconHome
            }}
            path={action.path}
            isMobile={isMobile}
            isAnimated={isAnimated}
            target={action.target}
          />
        ))}
      </div>
    </div>
  );
});

export default ActivityList;